"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinkedWrapper = exports.StyledSelect = exports.StyledIconSelect = exports.StyledInput = exports.StyledSelectContainer = exports.StyledButtonContainer = exports.StyledContainer = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem, getFontStyle } = ui_common_components_1.utils;
exports.StyledContainer = styled_components_1.default.form `
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Large)};
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  display: flex;
  flex-direction: column;
`;
exports.StyledButtonContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
  width: fit-content;
  ${({ variant, theme }) => (0, styled_components_1.css) `
    max-width: ${variant === 'tooltip'
    ? rem(theme.Components.PopupMenu.Button.Size)
    : 'auto'};
  `}

  & button {
    ${({ variant, theme }) => (0, styled_components_1.css) `
      max-width: ${variant === 'tooltip'
    ? rem(theme.Components.PopupMenu.Button.Size)
    : 'auto'};
    `}
  }
`;
exports.StyledSelectContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  min-width: ${rem(90)};
  width: ${rem(90)};
`;
exports.StyledInput = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  width: 100%;
`;
exports.StyledIconSelect = styled_components_1.default.div `
  position: absolute;
  display: flex;
  right: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
  top: 50%;
  transform: translateY(-50%);
  user-select: none;
`;
exports.StyledSelect = styled_components_1.default.select `
  ${({ theme }) => (0, styled_components_1.css) `
    border: ${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Border.Radius.Small)};
    padding: ${rem(theme.Spacing.Size.XXSmall)}
      ${rem(theme.Spacing.Size.XSmall)};
    background-color: transparent;
    color: ${theme.Color.Neutrals.Dark};
    ${getFontStyle('Body')}
    height: ${rem(theme.Form.InputSize.Medium.height)};
    outline: none;
    appearance: none;
    width: 100%;
  `}
`;
exports.StyledLinkedWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
//# sourceMappingURL=Link.styles.js.map